import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import { getImagePath } from 'src/utils/assetPaths';
import * as copy from '../constants/copy';
import * as styles from './FeefoAttribution.styles';

export interface FeefoAttributionProps {
  /** Tracking only; navigation is the link's own. */
  onRatingSystemInfoClick: () => void;
}

/**
 * The Feefo logo and the "Verified product reviews" link. Not the legacy `FeefoTooltip`,
 * which stacks them and is built on ribbons, which new code must not import. The link
 * keeps the legacy destination and `rel`.
 */
export const FeefoAttribution = ({ onRatingSystemInfoClick }: FeefoAttributionProps) => (
  <div css={styles.row}>
    {/* Called in render: `publicRuntimeConfig` is absent at module scope in Storybook. */}
    <img alt="Feefo" css={styles.logo} src={getImagePath('feefo-logo.png')} />
    <a
      css={styles.link}
      href={copy.RATING_HELP_HREF}
      onClick={onRatingSystemInfoClick}
      rel="nofollow"
    >
      <Icon aria-hidden name="info" size="sm" />
      {copy.VERIFIED_REVIEWS}
    </a>
  </div>
);

FeefoAttribution.displayName = 'FeefoAttribution';
